import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { actions } from 'modules/modal';
import { actions as userActions } from 'modules/user';
import { actions as applicationActions } from 'modules/application';
import { Navbar, NavbarBrand } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HeaderUserInfo from './components/HeaderUserInfo';
import * as styles from 'styles/index.scss';
import FRNLogo from 'images/SVG/FRN';
import FRNMobile from 'images/SVG/FRNMobile';
import Seperator from '../Seperator';

const { appHeaderContainer, appNavBarBrand } = styles;

// Product logos are only ever shown one at a time (on /products/:slug), so they're
// loaded lazily instead of eagerly bundling every product's logo into the main entrypoint.
const FFLogo = React.lazy(() => import('images/SVG/FF'));
const HBCLogo = React.lazy(() => import('images/SVG/HBC'));
const HHCLogo = React.lazy(() => import('images/SVG/HHC'));
const PBCCLogo = React.lazy(() => import('images/SVG/PBCC'));
const PPTLogo = React.lazy(() => import('images/SVG/PPT'));
const TNTGLogo = React.lazy(() => import('images/SVG/TNTG'));
const WLCLogo = React.lazy(() => import('images/SVG/WLC'));

const productSlugToLogo = {
  tntg: { Logo: TNTGLogo, props: { white: true } },
  'tntg-impactkit': { Logo: TNTGLogo, props: { white: true } },
  ff: { Logo: FFLogo, props: { white: true } },
  'ff-impactkit': { Logo: FFLogo, props: { white: true } },
  ppt: { Logo: PPTLogo, props: { white: true } },
  hbc: { Logo: HBCLogo, props: { white: true } },
  hhc: { Logo: HHCLogo, props: { white: true } },
  wlc: { Logo: WLCLogo, props: { white: true, height: 50, width: 100 } },
  pbcc: { Logo: PBCCLogo, props: { white: true, height: 50, width: 100 } },
  'pbcc-2024': { Logo: PBCCLogo, props: { white: true, height: 50, width: 100 } },
  'pbcc-2025': { Logo: PBCCLogo, props: { white: true, height: 50, width: 100 } },
  'pbcc-2026': { Logo: PBCCLogo, props: { white: true, height: 50, width: 100 } }
};

@connect(state => ({ user: state.user }), {
  getUserProducts: actions.getUserProducts,
  navigateTo: applicationActions.navigateTo,
  toggleProductNavigation: applicationActions.toggleProductNavigation
})
class HeaderV2 extends PureComponent {
  constructor(props) {
    super(props);
    this.path = this.props.location && this.props.location.pathname.split('/');
    this.handleNav = this.handleNav.bind(this);
  }

  handleNav(nav) {
    //logo navigation if in products
    if (nav === 'product' && this.path[1] && this.path[1] === 'products' && this.productInPath) {
      console.log(' this.props.history.push(`/products/${this.productInPath}`);');
      this.props.history.push(`/products/${this.productInPath}`);
    } else {
      this.props.history.push('/products');
    }
  }

  render() {
    const isCheckout = this.path[1] === 'checkout';
    const { firstName, img, isAuthenticated, showSideBar } = this.props;
    this.path = this.props.location && this.props.location.pathname.split('/');

    this.productInPath = this.path[2];
    const productLogo =
      this.path[1] && this.path[1] === 'products' && this.productInPath && productSlugToLogo[this.path[2]];
    const hasProduct = Boolean(productLogo);
    return (
      <Navbar className={`${appHeaderContainer} no-print`}>
        <div className="d-flex  flex-row align-middle ">
          <div className={`ml-2 ml-lg-3 d-flex flex-row pointerGlobal align-middle  `}>
            {this.productInPath == 'frs23' ? (
              <div onClick={this.props.toggleProductNavigation} style={{ fontSize: '1.5em' }} className="mr-4 pl-2">
                <FontAwesomeIcon icon="bars" />
              </div>
            ) : null}
          </div>
          {/* <div className="seperatorHeader"></div> */}
          <div className={` align-middle pointerGlobal ml-1 ml-lg-0`} onClick={() => this.handleNav('product')}>
            {/* Determine which logo to show based off the of the product slug */}
            {hasProduct ? (
              <React.Suspense fallback={null}>
                <productLogo.Logo {...productLogo.props} />
              </React.Suspense>
            ) : null}
          </div>
          {hasProduct ? <Seperator height={'24px'} /> : null}
          <div className={`d-none d-lg-inline-block `} onClick={() => this.handleNav('home')}>
            <FRNLogo white height={40} width={105} />
          </div>

          <div className="d-lg-none">
            <FRNMobile white height={40} width={50} />
          </div>
        </div>
        {!isCheckout ? (
          showSideBar ? (
            <div style={{ color: 'transparent' }}>.</div>
          ) : null // <FontAwesomeIcon onClick={toggleSideBar} className={appNavBarBarIcon} icon="bars" />
        ) : (
          <div style={{ color: 'transparent' }}>.</div>
        )}
        <div className="flexCenter">
          {isAuthenticated ? (
            <HeaderUserInfo firstName={firstName} img={img} />
          ) : (
            <NavbarBrand href="/" className="mr-auto" className={appNavBarBrand}>
              Food Revolution Network
            </NavbarBrand>
          )}
        </div>
      </Navbar>
    );
  }
}

HeaderV2.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  logoutUser: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  isAuthenticated: state.user.isAuthenticated,
  img: state.user.avatarUrl,
  firstName: state.user.firstName
});

const mapDispatchToProps = {
  logoutUser: userActions.logoutUser,
  openModal: actions.openModal,

  getUserProducts: actions.getUserProducts
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HeaderV2));
